import React, { Fragment } from 'react';
import cn from 'classnames';

import features from 'services/feature-manager';
import UserDevice from 'services/user-device';
import AcceptOddsChangeModal from '../AcceptOddsChangeModal';
import Betslip from '../Betslip';
import BetslipHeader from '../BetslipHeader';
import RefillBalanceModal from '../RefillBalanceModal';
import useBetslipList from './useBetslipList';

import './betslipList.scss';

const BetslipList: React.FC = () => {
    const { betslipBetIds, chosenBetslipBetId } = useBetslipList();
    const count = betslipBetIds.count();
    const lastBetslipBetId = betslipBetIds.last<undefined>();
    const isSolo = count === 1;

    const isRefillModal = features.isActive(
        features.list.BetslipRefillBalanceModal
    );

    return (
        <div
            styleName={cn('container', {
                solo: isSolo,
                'is-mobile': UserDevice.getInstance()?.isDeviceMobile(),
            })}
            className="__app-BetslipContainer-container"
        >
            {betslipBetIds.map(betslipBetId => {
                const isOpened = chosenBetslipBetId === betslipBetId;
                const isLast = lastBetslipBetId === betslipBetId;

                return (
                    <Fragment key={betslipBetId}>
                        <div
                            styleName={cn('header-wrapper', {
                                'is-opened': isOpened,
                            })}
                        >
                            <BetslipHeader
                                betslipBetId={betslipBetId}
                                isOpened={isOpened}
                                betslipBetsSize={count}
                            />
                        </div>

                        {!isLast && <div styleName="divider" />}

                        <Betslip
                            betslipBetId={betslipBetId}
                            isOpened={isOpened}
                        />
                    </Fragment>
                );
            })}

            {isRefillModal && lastBetslipBetId && (
                <RefillBalanceModal betslipBetId={lastBetslipBetId} />
            )}

            <AcceptOddsChangeModal />
        </div>
    );
};

export default React.memo(BetslipList);
